import { createSelector } from "@reduxjs/toolkit";
import {
  IActivityHistoryCustomFilterGroup,
  IActivityHistoryFilter,
  isCustomFilter,
} from "../model";
import { activityHistoryFiltersSelector } from "../selectors";

export const activityHistoryCustomFilterGroupsSelector = createSelector(
  activityHistoryFiltersSelector,
  (filters: IActivityHistoryFilter[]) => {
    const customFilters = filters.filter(isCustomFilter);
    return customFilters.sort(sortBySortProperty);
  },
);

const sortBySortProperty = (
  a: IActivityHistoryCustomFilterGroup,
  b: IActivityHistoryCustomFilterGroup,
) => Number(a.sort) - Number(b.sort);

export const areCustomFiltersActive = createSelector(
  activityHistoryCustomFilterGroupsSelector,
  (filters: IActivityHistoryCustomFilterGroup[]) => {
    return filters.some((filter) =>
      filter.filters.some((singleFilter) => singleFilter.enabledValues?.length),
    );
  },
);

export const activeGroupsWithEnabledFilters = createSelector(
  activityHistoryCustomFilterGroupsSelector,
  (filters: IActivityHistoryCustomFilterGroup[]) => {
    return filters
      .filter((group) => group.enabled)
      .map(({ id, title, enabled, sort, filters }) => ({
        id,
        title,
        enabled,
        sort,
        filters: filters.filter((filter) => filter.enabledValues?.length),
      }))
      .filter((group) => group.filters.length > 0);
  },
);
